var map = {
	"./background_bottom.png": 354,
	"./background_top.png": 355,
	"./byen.svg": 495,
	"./logo_brave.png": 496,
	"./logo_chrome.png": 497,
	"./logo_edge.png": 498,
	"./logo_firefox.png": 499,
	"./logo_opera.png": 500,
	"./maaler.svg": 501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 494;